import PrimaryBtn from "@/components/button/primaryBtn";
import TextAreaInputField from "@/components/form/text-area";
import en from "@/localization/en.json";
import SecondaryBtn from "@/components/button/secondaryBtn.jsx";

function AskQuestion({
  register,
  errors,
  handleSubmit,
  onClose,
  isProductQuestionLoading,
}) {
  return (
    <div>
      <form className="mt-[2rem]" onSubmit={handleSubmit}>
        <TextAreaInputField
          labelName={en["product.your_question"]}
          isFieldRequired={true}
          name="question"
          register={register}
          error={errors.question}
        />

        <div className="flex justify-end mt-[1.75rem]">
          <SecondaryBtn
            btnText="Cancel"
            onClick={onClose}
            className="w-full py-[0.875rem] md:w-[10rem] md:py-[1rem]"
          />

          <div className="ml-[1.25rem]">
            <PrimaryBtn
              isLoading={isProductQuestionLoading}
              className="w-[10.625rem] h-[3rem]"
              btnText={en["common.submit"]}
            />
          </div>
        </div>
      </form>
    </div>
  );
}

export default AskQuestion;
